import {
  Component,
  OnDestroy,
  OnInit,
} from "@angular/core";
import * as _lodash from "lodash";
import * as _underscore from "underscore";
import { CommonService } from "app/reusable/common.service";
import { environment } from "environments/environment";
import { takeUntil } from "rxjs/operators";
import { Subject } from "rxjs";
import { GetCaseType } from "app/_models/case-type/case-type.model";
import { CedNotificationService } from "ced-ng-library";

@Component({
  selector: "app-case-types-list",
  templateUrl: "./case-types-list.component.html",
  styleUrls: ["./case-types-list.component.scss"]
})
export class CaseTypesListComponent implements OnInit, OnDestroy {
  dataSource = [];
  value1 = "Yes";
  public serverUrlSlot3 : string = environment.Services.AlphaURLSlot2;
  value2 = "No";
  public dialogOpened = false;
  isDetailsOpened = false;
  private _subject$: Subject<boolean> = new Subject();
  casetype: GetCaseType;
  selectedCaseType;
  constructor(
    private commonService: CommonService,
    private cedNotificationService: CedNotificationService
  ) { }

  ngOnInit() {
    this.getCaseTypes();
  }

  getCaseTypes() {
    let GetCaseTypesUrl: string = `CaseType/GetAll`;
    this.commonService.getData(GetCaseTypesUrl, this.serverUrlSlot3)
      .pipe(takeUntil(this._subject$))
      .subscribe((data: any) => {
        this.dataSource = data;
      },
      (error) => {
        this.cedNotificationService.warning("NOTIFICATIONS.GET_CASE");
      });
  }

  ngOnDestroy(): void {
    this._subject$.unsubscribe();
  }

  copyMode: boolean;
  public Copy(id: string): void {
    this.ctyid = id;
    this.copyMode = true;
    this.isDetailsOpened = true;
  }

  openDetail() { 
    if(this.selectedCaseType != null)
    this.openDetails(this.selectedCaseType.ctyId);
    this.selectedCaseType = null; 
  }
 
  onCellClick($event) {
    this.selectedCaseType = $event.dataItem
  }
  
  ctyid: string;
  openDetails(id: string): void {
    this.ctyid = id;
    this.copyMode = false;
    this.isDetailsOpened = true;
  }

  openDelete(item: GetCaseType): void {
    this.casetype = item;
    this.dialogOpened = true;
  }

  public Delete(event) {
    this.dialogOpened = event.dialogstatus;
    this.dataSource = this.dataSource.filter((e) => e != event.CaseType);
    this.dataSource = [...this.dataSource];
  }

  public cancel() {
    this.ctyid = null;
    this.isDetailsOpened = false;
  }

  public save(event) {
    this.isDetailsOpened = false;
    this.getCaseTypes();
  }
}